<template>
  <div class="mb10" style="position:relative">
    <div :class="[animation ? 'transition' : 'transition1', 'project-step-cover']"></div>
    <p class="bottom-line dialog-title">
      {{ (radishProject['radish'] && radishProject['radish']['姓名']) || '未选择' }}
    </p>
    <el-button
      v-if="radishProject.状态 && (radishProject.状态.detail == '淘汰' || radishProject.状态.detail == '放弃')"
      class="mb10"
      type="primary"
      size="mini"
      @click="reStart"
      >重启人选</el-button
    >
    <el-button v-else class="mb10" type="primary" size="mini" @click="showInterview">安排客户面试</el-button>
    <p class="bottom-line dialog-title">推荐简历反馈</p>
    <div style="padding:10px;">
      <div>
        <p class="dialog-title mb10"><span style="color:red">*</span>简历筛选结果:</p>
        <el-radio-group v-model="temp.结果">
          <el-radio label="合适">合适</el-radio>
          <el-radio label="淘汰">不合适（人选淘汰）</el-radio>
          <el-radio label="待定">待定</el-radio>
        </el-radio-group>
        <p class="dialog-title" style="margin:10px 0">客户对候选人推荐反馈</p>
        <div
          v-for="(item, index) in managerFeedback"
          :key="`managerFeedback${index}`"
          :class="item && item.顾问 === user ? 'remark-self' : ''"
        >
          <span v-if="item.badge" class="badge-dot"></span>
          <span class="remark-date">
            {{ dateFormat(item.时间) }} <span class="remark-time">{{ dateFormat(item.时间, 'HH:MM') }}</span> --
            {{ item.顾问 }}
          </span>
          <span v-if="item.结果" style="padding-left: 10px;">结果：{{ item.结果 }}</span>
          <span style="padding-left: 10px;"> {{ item.内容 }}</span>
        </div>
        <el-input v-model="temp.客户经理反馈" class="flex-grow" type="textarea" size="mini" :rows="3" placeholder="">
        </el-input>
        <p class="dialog-title" style="margin:10px 0">候选人对客户提出问题的反馈</p>
        <div
          v-for="(item, index) in radishFeedback"
          :key="`radishFeedback${index}`"
          :class="item && item.顾问 === user ? 'remark-self' : ''"
        >
          <!-- <span class="remark-date">
            {{ dateFormat(item.时间) }} <span class="remark-time">{{ dateFormat(item.时间, 'HH:MM') }}</span> --
            {{ item.顾问 }}
          </span> -->
          <span v-if="item.badge" class="badge-dot"></span>
          <span class="remark-date">
            {{ dateFormat(item.时间) }} <span class="remark-time">{{ dateFormat(item.时间, 'HH:MM') }}</span> --
            {{ item.顾问 }}
          </span>
          <span v-if="item.结果" style="padding-left: 10px;">结果：{{ item.结果 }}</span>
          <span style="padding-left: 10px;"> {{ item.内容 }}</span>
        </div>
        <el-input v-model="temp.候选人反馈" class="flex-grow" type="textarea" size="mini" :rows="3" placeholder="">
        </el-input>
        <div class="textarea-btn-box"><el-button type="primary" size="mini" plain @click="save">保存</el-button></div>
      </div>
    </div>
    <!-- 面试弹窗 -->
    <ProgressDia ref="ProgressDia" :on-confirm="loadData"></ProgressDia>
  </div>
</template>
<script>
import ProgressDia from '../../../../radish/src/progress/progress-dia.vue'

const dateFormat = require('dateformat')

export default {
  components: { ProgressDia },
  props: {
    project: { type: Object, default: () => ({}) },
    step: { type: String, default: '' },
    radishProject: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      result: '',
      temp: {},
      managerFeedback: [],
      radishFeedback: [],
      user: '',
      animation: false,
    }
  },
  computed: {
    isCustomerManager() {
      const manger = this.project.客户开发 || []
      return manger.includes(app.user.account)
    },
  },
  watch: {
    radishProject: {
      handler(newValue, oldValue) {
        if (newValue && newValue._id) {
          this.init()
        }
      },
      immediate: true,
    },
    project: {
      handler(newValue, oldValue) {
        if (newValue && newValue._id) {
          this.init()
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.user = app.user.account
  },
  methods: {
    async init() {
      await this.getRecommend()
      await this.getFeedBack()
      this.animation = !this.animation
    },
    showInterview() {
      if (!this.radishProject._id) return this.$message.error('请先选择人选')
      this.$refs.ProgressDia.open({ radish: this.radishProject.radish, project: this.project, compName: 'InterviewCreate' })
    },
    getStorage() {
      const storage = localStorage.getItem('recommendHistory')
      const obj = (storage && JSON.parse(storage)) || {}

      this.recommendHistory = obj
    },
    updateStorage({ _id, arr }) {
      const storage = localStorage.getItem('recommendHistory')
      let obj = {}
      try {
        obj = (storage && JSON.parse(storage)) || {}
      } catch (e) {
        console.log(e)
      }
      arr.forEach(v => {
        delete v.badge
      })
      obj[_id] = arr
      localStorage.setItem('recommendHistory', JSON.stringify(obj))
    },
    getRecommend() {
      if (this.recommend) this.clearTemp()
      const recommends = this.project.recommends
      const recommend = recommends.find(val => val.rid === this.radishProject.rid)
      this.recommend = recommend
    },
    clearTemp() {
      const fields = ['结果', '客户经理反馈', '候选人反馈']
      fields.forEach(field => {
        this.$set(this.temp, field, null)
      })
    },
    async sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    async getFeedBack() {
      this.getStorage()
      const { recommendHistory } = this
      const account = app.user.account

      const recommend = this.project.recommends.find(val => val.rid === this.radishProject.rid)
      if (!recommend) return
      const feedbacks = (recommend && recommend.推荐反馈) || []
      feedbacks.sort((a, b) => a.时间 - b.时间)
      this.managerFeedback = feedbacks.filter(v => v.类型 === '客户经理')
      this.radishFeedback = feedbacks.filter(v => v.类型 === '候选人')

      const arr = recommendHistory[recommend._id] || []
      let updateStorageFlag = false
      this.managerFeedback.forEach(val => {
        // 查找填写数据的是当前用户，或者历史查记录中是否包含此条数据的，如果找到，说明不用显示红点
        const a = val.user === account || arr.find(v => JSON.stringify(v) === JSON.stringify(val))
        this.$set(val, 'badge', !a)
        if (!a) updateStorageFlag = true
      })
      this.radishFeedback.forEach(val => {
        // 查找填写数据的是当前用户，或者历史查记录中是否包含此条数据的，如果找到，说明不用显示红点
        const a = val.user === account || arr.find(v => JSON.stringify(v) === JSON.stringify(val))
        this.$set(val, 'badge', !a)
        if (!a) updateStorageFlag = true
      })
      if (updateStorageFlag) this.updateStorage({ _id: recommend._id, arr: feedbacks })
    },
    async save() {
      if (!this.recommend) return this.$message.error('请选择候选人')

      // const data = []
      // if (this.temp.客户经理反馈) data.push({ 类型: '客户', 内容: this.temp.客户经理反馈, 结果: this.temp.结果 })
      // if (this.temp.候选人反馈) data.push({ 类型: '候选人', 内容: this.temp.候选人反馈, 结果: this.temp.结果 })

      // if (data.length === 0) return this.$message.error('请填写反馈内容')

      // const res = await app.service('radish').addRecommendFeedBack({ feedbacks: data, id: this.recommend._id })
      const res = await app
        .service('radish')
        .addFeedback({ data: this.temp, _id: this.recommend._id, type: 'recommend' })
      if (res.status === 'success') {
        await this.findRecommend()
        // Object.assign(this.recommend, { 推荐反馈: res.data.推荐反馈 })
        this.clearTemp()
        this.getFeedBack()
        // this.$emit('reloadProject', this.project)
        this.$message.success('保存成功')
      } else this.$message.error(res.msg)
    },
    async findRecommend() {
      if (!this.recommend) return
      const res = await app.service('radish').findRecommend({ rid: this.recommend.rid, pid: this.recommend.pid })
      if (res.status === 'success') {
        if (res.data.length > 0) {
          Object.assign(this.recommend, res.data[0])
        } else {
          this.$message.error('未找到对应推荐数据')
        }
      } else {
        this.$message.error(res.msg)
      }
    },
    loadData() {
      this.$emit('removeRecommend', this.radishProject)
      this.$emit('reloadProject', this.project)
    },
    dateFormat(val, type) {
      return val ? dateFormat(val, type || 'yyyy-mm-dd') : ''
    },

    passed(date) {
      return date ? `${Math.ceil((Date.now() - date) / (24 * 3600 * 1000))}` : ''
    },
    reStart() {
      this.$confirm('确定要重启人选吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          // 重启
          await app.service('radish').reStartProgress({ rid: this.radishProject.rid, pid: this.project._id })
          this.loadData()
        }).catch(() => {
        });
    },
  },
}
</script>
<style scoped>
.bolder {
  font-weight: 700;
}
.project-step-cover {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: #fff;
  opacity: 0;
}
.project-step-cover.transition {
  animation: totransprant 0.5s forwards;
}
.project-step-cover.transition1 {
  animation: totransprant1 0.5s forwards;
}
@keyframes totransprant {
  0% {
    z-index: 1;
    opacity: 1;
  }
  100% {
    opacity: 0;
    z-index: -1;
  }
}
@keyframes totransprant1 {
  0% {
    z-index: 1;
    opacity: 1;
  }
  100% {
    opacity: 0;
    z-index: -1;
  }
}
.bottom-line:after {
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background-color: #c5c5c5;
  margin-top: 5px;
  margin-bottom: 10px;
}
.textarea-btn-box {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}
.dialog-title {
  font-size: 16px;
  font-weight: 700;
  color: #4a4848;
}
.badge-dot {
  height: 8px;
  width: 8px;
  padding: 0;
  right: 0;
  border-radius: 50%;
  background-color: #f56c6c;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  white-space: nowrap;
}
</style>
